import React from 'react';

import { NikeCmsMarkdownModules } from 'nike-ui/src/types/generated/nike-cms-markdown-modules';
import { useStreamingModule } from 'nike-ui/src/components/streams/cms-streaming-module';
import { StreamingModuleVideo } from '@/markdown/modules/StreamingModuleVideo';

export const StreamingModule = (props: NikeCmsMarkdownModules.StreamingModule) => {
    const {
        url,
        matchId,
        startTime,
        sport,
        sportId,
        provider,
        moduleState,
        onRestart,
        stream,
        tournamentId
    } = useStreamingModule(props);
    return (
        <StreamingModuleVideo
            src={url}
            matchId={matchId}
            startTime={startTime}
            sport={sport}
            sportId={sportId}
            tournamentId={tournamentId}
            provider={provider}
            moduleState={moduleState}
            onRestart={onRestart}
            expirationIntroDate={stream?.expirationIntroDate}
        />
    );
};
